import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import reportWebVitals from "./reportWebVitals";

import Navigation from "./Components/Navigation/Navigation";
import Main from "./Components/Main/Main";
import AboutMe from "./Components/AboutMe/AboutMe";
import ServicesContent from "./Components/ServicesContent/ServicesContent";
import Questions from "./Components/Questions/Questions";
import Footer from "./Components/Footer/Footer";
import Reviews from "./Components/Reviews/Reviews";
import Work from "./Components/Work/Work";

import { HelmetProvider } from "react-helmet-async";
import SEO from "./Components/SEO";
import CookieConsent from "./Components/CookieConsent/CookieConsent";
import Policy from "./Components/Policy/Policy";
import { BrowserRouter, Routes, Route } from "react-router-dom";

const COUNTER_ID = 99221534;

const initMetrica = () => {
  if (window.ym) return;

  (function (m, e, t, r, i, k, a) {
    m[i] =
      m[i] ||
      function () {
        (m[i].a = m[i].a || []).push(arguments);
      };
    m[i].l = 1 * new Date();
    k = e.createElement(t);
    a = e.getElementsByTagName(t)[0];
    k.async = 1;
    k.src = r;
    a.parentNode.insertBefore(k, a);
  })(window, document, "script", "https://mc.yandex.ru/metrika/tag.js", "ym");

  window.ym(COUNTER_ID, "init", {
    clickmap: true,
    trackLinks: true,
    accurateTrackBounce: true,
  });
};

// Проверяем сохраненное согласие в localStorage
const hasConsent = localStorage.getItem("userHasAcceptedCookies");
if (hasConsent === "true") {
  initMetrica();
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route
          path="/"
          element={
            <>
              <CookieConsent onAccept={initMetrica} />
              <HelmetProvider>
                <SEO
                  title="Интернет-страничка мастера бровиста Алены Трошиной в Чехове!"
                  description="На моем сайте вы можете записаться на брови, ресницы и макияж в Чехове!"
                  name="Запись на брови, ресницы и перманентный макияж в Чехове к Алене Трошиной"
                  type="website"
                />
                <Navigation />
                <Main />
                <AboutMe />
                <ServicesContent />
                <Work />
                <Questions />
                <Reviews />
                <Footer />
              </HelmetProvider>
            </>
          }
        />
        <Route path="/policy" element={<Policy />} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>,
);

reportWebVitals();
